import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useController, UseControllerProps } from 'react-hook-form'
import { FormHelperText, IconButton, InputAdornment, Tooltip } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useEffect, useState } from 'react';
import { formControlColour, tooltipColour } from '../BEE123.Constants';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export interface IDropDownOptions {
    id: string | number,
    value: string
}
interface IProps extends UseControllerProps {
    label: string;
    items: IDropDownOptions[];
    size?: "small" | "medium";
    disabled?: boolean;
    disabledItems?: (string | number)[];
    onChange?: (value: any) => void;
    showDescription?: boolean;
    descriptionText?: string;
    treatZeroAsEmpty?: boolean;
}

const AppSelectList = (props: IProps) => {
    const { fieldState, field } = useController({ ...props, defaultValue: props.defaultValue != null ? props.defaultValue : '' });
    const [open, setOpen] = useState<boolean>(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const [displayValue, setDisplayValue] = useState(field.value);

    useEffect(() => {
        if (props.treatZeroAsEmpty && field.value === 0) {
            setDisplayValue('');
        } else {
            setDisplayValue(field.value);
        }
    }, [field.value, props.treatZeroAsEmpty]);

    return (
        <FormControl fullWidth error={!!fieldState.error}>
            <InputLabel disabled={props.disabled}>{props.label}</InputLabel>
            <Select
                open={open}
                value={displayValue}
                label={props.label}
                onChange={(value) => {
                    field.onChange(value);
                    if (props.onChange) {
                        if (value != null) {
                            const option = value.target.value;
                            props.onChange(option);
                        }
                    }
                }}
                onClose={handleClose}
                onOpen={handleOpen}
                sx={{
                    padding: "0.75rem 0 !important",
                    fontSize: "0.875rem"
                }}
                size={props.size}
                disabled={props.disabled}
                endAdornment={
                    displayValue !== null && (
                        <InputAdornment position="end">
                            {props.showDescription &&
                                <Tooltip
                                    title={props.descriptionText!}
                                    arrow
                                    componentsProps={{
                                        tooltip: {
                                            sx: {
                                                bgcolor: tooltipColour,
                                                '& .MuiTooltip-arrow': {
                                                    color: tooltipColour
                                                },
                                            },
                                        },
                                    }}
                                    placement="right"
                                >
                                    <IconButton
                                        size="small"
                                        edge="end"
                                        color="inherit"
                                        aria-label="info"
                                    >
                                        <InfoOutlinedIcon style={{ color: formControlColour }} />
                                    </IconButton>
                                </Tooltip>
                            }
                            {displayValue !== '' && (
                                <IconButton
                                    size="small"
                                    onClick={() => {
                                        field.onChange(props.defaultValue != null ? props.defaultValue : null);
                                    }}
                                    disabled={props.disabled}
                                >
                                    <ClearIcon />
                                </IconButton>
                            )}
                            <IconButton
                                style={{ paddingLeft: "0px" }}
                                onClick={handleOpen}
                                disabled={props.disabled}
                            >
                                <ArrowDropDownIcon />
                            </IconButton>

                        </InputAdornment>
                    )
                }
            >
                {props.items.map((item) => (
                    <MenuItem key={item.id} value={item.id} disabled={props.disabledItems?.includes(item.id)}>{item.value}</MenuItem>
                ))}
            </Select>
            <FormHelperText>{fieldState.error?.message}</FormHelperText>
        </FormControl>
    )
}

export default AppSelectList